type PredefinedContext = { id: number; data: any };

type ContextField = {
    id: number;
    label: string;
};

export type RoleInformation = {
    id: number;
    name: string;
    contextField?: ContextField;
    predefinedContexts: PredefinedContext[];
};

export type ClientInformation = {
    id: number;
    display_name: string;
    roles: Record<number, RoleInformation>;
};

/**
 * Collects role informmation in a format needed by the frontend.
 *
 * roleRows, roleContextRows and contextRows are simple list requests to the respective endpoints.
 */
export function collectClientRoles(
    clientId: number,
    roleRows: any[],
    roleContextRows: any[],
    contextRows: any,
    skipRoles: string[],
) {
    function roleContext(id: number) {
        return roleContextRows.find((context: any) => context.id === id);
    }
    function context(id: number) {
        return contextRows.find((context: any) => context.id === id);
    }

    const clientRoles: Record<number, RoleInformation> = {};
    roleRows.forEach((role) => {
        if (role.client && role.client.id === clientId) {
            if (skipRoles.includes(role.name)) {
                return;
            }

            const predefinedContexts: PredefinedContext[] = role.role_contexts
                .map((rcDef: any) => {
                    const rc = roleContext(rcDef.id);
                    if (rc.predefined_value === null) {
                        return null;
                    }

                    return { id: rc.context.id, data: rc.predefined_value };
                })
                .filter((v: string) => v !== null);

            const contexts: ContextField[] = role.role_contexts
                .map((rcDef: any) => {
                    const rc = roleContext(rcDef.id);
                    if (rc.predefined_value === null) {
                        const schemaDesc = Object.values(context(rc.context.id).schema)[0] as any;
                        return {
                            id: rc.context.id,
                            label: schemaDesc.name as string,
                        };
                    }
                    return null;
                })
                .filter((v: string) => v !== null);

            if (contexts.length > 1) throw new Error("We do not support multiple contexts");

            clientRoles[role.id] = {
                id: role.id,
                name: role.name,
                contextField: contexts?.[0] || null,
                predefinedContexts,
            };
        }
    });
    return clientRoles;
}
